import { useDispatch, useSelector } from "react-redux"
import { CloseIcon, CubeIconSmall } from "../../Shared/Components/SvgIcons"
import { setModalData } from "../../Shared/SharedSlices/ModalSlice"
import { RootState } from "../../../App/store"

function RoomDescriptionModal() {
    const dispatch = useDispatch()
    
    const roomDataState = useSelector((state: RootState) => state.roomSlice.roomSlice.room)

    const onModalClose = () => {
        dispatch(setModalData({ open: false, roomDescriptionModal: false }))
    }

    return (
        <div className="room-description-modal">
            <div className="room-members-modal__header">
                <div className="room-members-modal__text">
                    <div className="room-members-modal__mobile-icon">
                        <CubeIconSmall />
                    </div>
                    Raumbeschreibung
                </div>
                <div className="room-members-modal__close-icon room-members-modal__close-icon--mobile-icon" onClick={onModalClose}>
                    <CloseIcon />
                </div>
            </div>
            <div className="room-description-modal__description" dangerouslySetInnerHTML={{ __html: roomDataState.description! }} />
        </div>
    )
}

export default RoomDescriptionModal
